import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Common } from '../lib/common-methods';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { Source } from '../model/source';

@Component({
  selector: 'app-source-modal',
  templateUrl: './source-modal.component.html',
  styleUrls: ['./source-modal.component.scss']
})
export class SourceModalComponent implements OnInit {

  @ViewChild('modal_source') modal!: ModalDialogComponent;

  @Input() selectedTag: Source = new Source();
  @Output() onClose: EventEmitter<Source> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  show() {
    this.modal.show();
  }

  isValid(): boolean {
    return !Common.isNullOrEmpty(this.selectedTag?.companyTitle) ||
      !Common.isNullOrEmpty(this.selectedTag?.contactSurname) ||
      !Common.isNullOrEmpty(this.selectedTag?.contactName);
  }

  modalClosed(ok: boolean): void {
    if (ok == false) {
      return;
    }

    this.onClose.emit(this.selectedTag);
  }

}
